import { render, staticRenderFns } from "./EventClasses.vue?vue&type=template&id=6a2dcd8b&"
import script from "./EventClasses.vue?vue&type=script&lang=js&"
export * from "./EventClasses.vue?vue&type=script&lang=js&"
import style0 from "./EventClasses.vue?vue&type=style&index=0&id=6a2dcd8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports